<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="edit-article-dialog"
  >
    <article-form
      ref="outform"
      :form-data="rowData"
      @submit="submit"
    ></article-form>
  </sliderBarDialogShell>
</template>

<script>
import articleForm from "@/components/wx/article/articleForm";
import {addArticle} from "@/api/wx/acticle";
import {saveArticle} from "../../../api/wx/acticle";

export default {
  name: "editArticleDialog",
  components: {
    articleForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  watch:{
    dialogShow(val){
      if(val && this.rowData.id){
        setTimeout(()=> {
          this.$refs.outform.assigen(this.rowData);
        },200);
      }
    }
  },
  data() {
    return {
      title: '编辑公众号文章'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      //增加和编辑接口是一样
      saveArticle(form).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .edit-article-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
